import moment from 'moment-timezone'
import CryptoJS from 'crypto-js'
import { v4 as uuidv4 } from 'uuid'
import { EventType, ID10xOptPageParams } from './App'

const devBaseUrl = 'https://us-central1-seamless-dev-53a8d.cloudfunctions.net/d10x'
const prodBaseUrl = 'https://us-central1-seamless-pro.cloudfunctions.net/d10x'

const devDatabaseURL = 'https://seamless-dev-53a8d.firebaseio.com'
const prodDatabaseURL = 'https://seamless-pro.firebaseio.com'

const getIdToken = async (date: string) => {
  let res = ''
  try {

    // get the timestampe from the request and format it "hh:mm:ss aaa, yyyy, MMM dd" and us Locale
    const localMoment = moment.utc(date).locale('en')
    const d = localMoment.format('hh:mm:ss A, YYYY, MMM DD')
    // get project data base url,
    // split that url String with '2' regex & use only the first substring.
    const dbURL = process.env.REACT_APP_ENV === 'dev' ? devDatabaseURL : prodDatabaseURL
    res = CryptoJS.HmacSHA256(d, dbURL).toString(CryptoJS.enc.Hex)
  } catch (error) {
    return ''
  }
  return res
}

let DEVICE_ID = ''

export const setUUID = () => {
  const localUUID = localStorage.getItem("UUID")
  const uuid = localUUID ?? uuidv4()
  localStorage.setItem("UUID", uuid)
  DEVICE_ID = uuid
}

const getRequestHeaders = (idToken: string, installId: string, date: string) => ({
  headers: {
    'content-type': 'application/json',
    authorization: `Bearer ${idToken}`,
    'X-Install-Id': installId,
    // 'Accept-Language': i18n.language,
    'X-Timezone': moment.tz.guess(),
    'X-Platform': 'WEB',
    'X-Inapp-Client': 'WEB',
    // 'X-Version-Name': process.env.REACT_APP_VERSION as string,
    // 'X-Version-Number': '0', // TODO - version number
    'X-date': date,
  },
})

export const report = async (eventType: EventType, data: any) => {
  const baseUrl = process.env.REACT_APP_ENV === 'dev' ? devBaseUrl : prodBaseUrl
  const url = `${baseUrl}/recordOptInPageAnalytics`

  const localMoment = moment.utc().locale('en')
  const DATE_RFC2822 = 'ddd, DD MMM YYYY HH:mm:ss [GMT]'
  const date = localMoment.format(DATE_RFC2822)

  const idToken = await getIdToken(date)

  console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV)

  const body = {
    eventType,
    ...data
  }

  const headers = getRequestHeaders(idToken, DEVICE_ID, date)

  await fetch(url, {
    method: 'POST',
    headers: headers.headers,
    body: JSON.stringify(body)
  })
}